// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardLeftNavigation.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from "react";
import connect from "share/enhancers/Izenda.Connect";
import CategoryTree from "share/components/controls/CategoryTree/Izenda.CategoryTree";
import Sidebar from "share/components/layout/Izenda.Sidebar";
import routeUtils from "share/utils/Izenda.RouteUtils";
import { observe } from "mobx";
import uiState from "logic/Izenda.UiState";

@connect()
export default class DashboardLeftNavigation extends Component {
  constructor(props) {
    super(props);
    this.urlList = routeUtils.getConfigRoute("Dashboard", "List");
  }

  static propTypes = {
    store: React.PropTypes.object
  };

  componentDidMount() {
    const { loader, store } = this.props;

    //observe tenant change --> reload data itself and close loader.
    this.disposeObserveTenantId = observe(uiState, "tenantId", () => {
      store.loadLazyLoadingCategories(true, null).finally(loader.endLoading.bind(loader));
    });
  }

  validateCategoryName = (category: Object) => {
    const { store } = this.props;
    return store.validateCategoryName(category);
  }

  registerLeftMenuLazyLoadingStore = (lazyLoadingStore: Object) => {
    const { store } = this.props;
    store.registerLeftMenuLazyLoadingStore(lazyLoadingStore);
  }

  loadLazyLoadingCategories = (pageInfo) => {
    const { store } = this.props;
    store.loadLazyLoadingCategories(false, pageInfo);
  }

  loadDashboardList = (catId: String) => {
    const { store } = this.props;
    return store.lazyLoadingDashboards(catId, true, null);
  }

  componentWillUnmount() {
    this.disposeObserveTenantId();
  }

  render() {
    const {
      store,
      store: { model: { leftMenuCategoryTree: dataTree, isLeftMenuLastPage } },
      store: { dashboardDesignerMode: { isPresentation, isFullscreen }},
      store: { selectedCategoryId }
    } = this.props;

    const routeParams = {
      catId: { dataKey: "id", value: null },
      dashboardId: { dataKey: "dashboardId", value: null },
      isGlobal: { dataKey: "isGlobal", value: null }
    };

    return (
      !isPresentation && !isFullscreen &&
      <Sidebar className="izenda-Content-Sidebar" isHiddenOnCollapsed hasScrollBox={false}>
        <CategoryTree
          store={store}
          dataTree={dataTree}
          isLastPage={isLeftMenuLastPage}
          selectedCategoryId={selectedCategoryId}
          routeObject={this.urlList}
          routeParams={routeParams}
          onLoadCategoryList={this.loadDashboardList}
          onValidateCategoryName={this.validateCategoryName}
          registerLazyLoadingStore={this.registerLeftMenuLazyLoadingStore}
          getData={this.loadLazyLoadingCategories}
        />
      </Sidebar>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/LeftNavigation/Izenda.DashboardLeftNavigation.js